import { store } from './store/store'

export default {
  install (Vue) {
    Vue.mixin({
      data: function () {
        return {
          $token: null
        }
      },
      methods: {
        $alertMsg (content, title = '', getButtonEvent = () => {}) {
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: title ? `<dl class="txt"><dt>${title}</dt><dd>${content}</dd></dl>` : `<p class="txt">${content}</p>`,
            getButtonEvent: () => getButtonEvent()
          })
        },
        $confirmMsg (title, content, getButtonEvent, btnName) {
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            getBtnCount: 2,
            getBtnName: !btnName ? '保存' : btnName,
            getButtonEvent: () => getButtonEvent(),
            messageHTML: title ? `<dl class="txt"><dt>${title}</dt><dd>${content}</dd></dl>` : `<p class="txt">${content}</p>`
          })
        },
        $checkAction (pms) {
          const action = store.getters.getPathActions ? store.getters.getPathActions.filter(item => item.value === pms) : 0
          return !!action.length
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/global_event.js